<template>
  <div class="function-container">
    <van-image :src="$dyyy(16)"></van-image>

    <van-image class="margin-lr-14 margin-bottom-12 border-dash" v-for="(item, index) in list" :key="item.id" :class="{ 'menu-first': index === 0 }" :src="$dyyy(item.icon)" @click="$router.push(item.path)"></van-image>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [
        {
          id: 1,
          icon: '17',
          path: '/dyyy/function/confirm-get-in'
        },
        {
          id: 2,
          icon: '18',
          path: '/dyyy/function/recieve-order-skill'
        },
        {
          id: 3,
          icon: '19',
          path: '/dyyy/function/auto-recieve-order'
        },
        {
          id: 4,
          icon: '20',
          path: '/dyyy/function/carpooling-skill'
        },
        {
          id: 5,
          icon: '21',
          path: '/dyyy/function/cancel-order'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.function-container {
  background-color: #fff;
  min-height: 100vh;
}
.menu-first {
  position: relative;
  margin-top: -16px;
}

.border-dash {
  border: 1px dashed $grey1;
}
</style>
